import React, { useState, useEffect } from 'react';
import { firestore } from '../config/firebaseConfig';
import { collection, query, where, getDocs } from 'firebase/firestore';
import './CursosDoProfessor.css';

function CursosDoProfessor({ professorId }) {
  const [cursos, setCursos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCursosDoProfessor = async () => {
      try {
        const cursosRef = collection(firestore, 'cursos');
        const q = query(cursosRef, where('professores', 'array-contains', professorId));
        const querySnapshot = await getDocs(q);
        const cursosData = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setCursos(cursosData);
      } catch (error) {
        console.error('Erro ao buscar cursos do professor:', error);
      } finally {
        setLoading(false);
      }
    };

    if (professorId) {
      fetchCursosDoProfessor();
    }
  }, [professorId]);

  if (loading) {
    return <div className="cursos-do-professor">Carregando cursos...</div>;
  }

  return (
    <div className="cursos-do-professor">
      <h2>Cursos ministrados e em andamento</h2>
      {cursos.length > 0 ? (
        <table className="cursos-table">
          <thead>
            <tr>
              <th>Curso</th>
              <th>Carga</th>
              <th>Turma</th>
              <th>Modalidade</th>
            </tr>
          </thead>
          <tbody>
            {cursos.map(curso => (
              <tr key={curso.id}>
                <td>{curso.nomeCurso}</td>
                <td>{curso.cargaHr}</td>
                <td>{curso.turma}</td>
                <td>{curso.modalidade}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>Nenhum curso encontrado para este professor.</p>
      )}
    </div>
  );
}

export default CursosDoProfessor;
